module.exports = __webpack_public_path__ + "img/magic.a19065bc.svg";